import Badge from './badge';

const { variants, defaultProps } = Badge;

const baseStyle = {
  fontFamily: 'mono',
  fontSize: 'sm',
  px: '0.2em',
  borderRadius: 'sm',
};

export default {
  baseStyle,
  variants,
  defaultProps,
};
